import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Button,
  InputBase,
  Menu,
  MenuItem,
  TableCell,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
  ArrowRightCircleIcon,
  DownArrowIcon,
} from "../../assets/Icon/ArrowIcon";
import { CrossIcon } from "../../assets/Icon/ModalIcon";
import CommonPagination from "../../components/common-components/CommonPagination";
import CustomTable from "../../components/common-components/CustomTable";
import ListLoadingNew from "../../components/common-components/ListLoadingNew";
import NoOrdersFound from "../../components/common-components/NoOrdersFound";
import {
  CloseButton,
  CloseButtonWrapper,
} from "../../components/style/modalStyleLarge";
import { getOrderList, setSelectedOrder } from "../../stores/orders";
import { useAppDispatch } from "../../stores/store";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { FIlterIcon } from "../../assets/Icon/headerCicon";
import { Formik } from "formik";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const Orders = () => {
  const dispatch = useAppDispatch();
  const {
    data: orderList,
    status,
    error,
    total_records,
  } = useSelector((state: any) => state.orders);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState<any>("");
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [limit] = useState(10);
  const [debouncedSearch, setDebouncedSearch] = useState<string>("");
  const filterRef = useRef<HTMLDivElement>(null);
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [startDateOpen, setStartDateOpen] = React.useState(false);
  const [endDateOpen, setEndDateOpen] = React.useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const statusRef = useRef<HTMLDivElement>(null);
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const [filterStatusValue, setFilterStatusValue] = useState("");
  const [selectedStatusId, setSelectedStatusId] = useState<number | null>(null);
  const [appliedFilterValues, setAppliedFilterValues] = useState<number[]>([]);
  const [tempFilterValues, setTempFilterValues] = useState<number[]>([]);
  const [openFilterStatus, setOpenFilterStatus] = useState<boolean>(false);

  const STATUS = [
    { id: 0, label: "Pending" },
    { id: 1, label: "Submitted" },
    { id: 2, label: "Completed" },
    { id: 3, label: "Under review" },
    { id: 4, label: "Ready for signature" },
  ];

  const navigate = useNavigate();
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  const fetchData = async () => {
    try {
      setLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 200));
      const offset = (page - 1) * limit;
      const isAnyFilterApplied =
        selectedStatusId !== null || !!startDate || !!endDate;

      if (isAnyFilterApplied) {
        setIsFilterApplied(true);
      }
      const result = await dispatch<any>(
        getOrderList({
          offset,
          limit,
          search: searchQuery.trim(),
          start_date: startDate
            ? dayjs
                .utc(startDate.format("YYYY-MM-DD"))
                .toISOString()
                .split("T")[0]
            : "",
          end_date: endDate
            ? dayjs
                .utc(endDate.format("YYYY-MM-DD"))
                .toISOString()
                .split("T")[0]
            : "",
          status: selectedStatusId,
        }),

        setOpenFilter(false),
      );
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, limit, debouncedSearch]);

  const resetFilters = async () => {
    const result = await dispatch<any>(
      getOrderList({
        offset: 0,
        limit,
        search: "",
        start_date: "",
        end_date: "",
        status: null,
      }),
    );
    setIsFilterApplied(false);
    setFilterStatusValue("");
    setSelectedStatusId(null);
    setStartDate(null);
    setEndDate(null);
    setPage(1);
  };

  const operatingAgreementStatus: Record<
    number,
    { label: string; bgColor: string; textColor: string }
  > = {
    0: { label: "Pending", bgColor: "#FFF5DB", textColor: "#E7AB12" },
    1: {
      label: "Submitted",
      bgColor: "#EAF1FA",
      textColor: "#2977CC",
    },
    2: {
      label: "Completed",
      bgColor: "#D9FFD2",
      textColor: "#3DC826",
    },
    99: { label: "Deactivated", bgColor: "#ff000020", textColor: "#ff0000" },
  };

  const itinStatus: Record<
    number,
    { label: string; bgColor: string; textColor: string }
  > = {
    0: { label: "Pending", bgColor: "#FFF5DB", textColor: "#E7AB12" },
    1: {
      label: "Ready For Signature",
      bgColor: "#FFF5DB",
      textColor: "#E7AB12",
    },
    2: { label: "Under Review", bgColor: "#FFF5DB", textColor: "#E7AB12" },
    3: { label: "Submitted", bgColor: "#EAF1FA", textColor: "#2977CC" },
    4: { label: "Completed", bgColor: "#D9FFD2", textColor: "#3DC826" },
    99: { label: "Deactivated", bgColor: "#ff000020", textColor: "#ff0000" },
  };
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
    setPage(1);
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
    setCurrentPage(newPage);
  };

  const LlcStatus: Record<
    number,
    { label: string; bgColor: string; textColor: string }
  > = {
    0: { label: "Pending", bgColor: "#FFF5DB", textColor: "#E7AB12" },

    1: { label: "Under Review", bgColor: "#FFF5DB", textColor: "#E7AB12" },
    3: { label: "Submitted", bgColor: "#EAF1FA", textColor: "#2977CC" },
    2: { label: "Completed", bgColor: "#D9FFD2", textColor: "#3DC826" },
    4: { label: "Completed", bgColor: "#D9FFD2", textColor: "#3DC826" },
    5: { label: "Completed", bgColor: "#D9FFD2", textColor: "#3DC826" },
    6: { label: "Completed", bgColor: "#D9FFD2", textColor: "#3DC826" },
    7: { label: "Completed", bgColor: "#D9FFD2", textColor: "#3DC826" },
    99: { label: "Deactivated", bgColor: "#ff000020", textColor: "#ff0000" },
  };

  const handleSelect = (orderId: number, productId: number, userId: number) => {
    // console.log(productId,"hhhh")
    dispatch<any>(setSelectedOrder({ orderId, productId, userId }));
    if (productId === 5) {
      navigate(`/admin-orders-operating-agreement/${orderId}`);
      return;
    }
    navigate(`/admin-orders/${orderId}`);
  };

  const formatToTimeZone = (
    dateInput: string | Date,
    timeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone,
    locale: string = "en-US",
    options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "short",
      day: "2-digit",
    },
  ): string => {
    if (!dateInput) return "Invalid Date";

    const date = new Date(
      typeof dateInput === "string" && !dateInput.endsWith("Z")
        ? dateInput + "Z"
        : dateInput,
    );

    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }

    return new Intl.DateTimeFormat(locale, {
      timeZone,
      ...options,
    }).format(date);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      // ✅ Ignore clicks inside DatePicker popup
      if (target.closest(".MuiPickersPopper-root")) {
        return;
      }

      // ✅ Ignore clicks inside MUI Menu (Category dropdown)
      if (target.closest(".MuiPopover-root")) {
        return;
      }

      // ✅ Close only if click is outside the filter container
      if (filterRef.current && !filterRef.current.contains(target)) {
        setOpenFilter(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <StyledBox sx={{ paddingY: "16px" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: "20px",
            padding: "20px",
            "@media (min-width: 600px)": {
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            },
          }}
        >
          <Title>Orders</Title>

          <div style={{ display: "flex", gap: 30, alignItems: "center" }}>
            <div style={{ display: "flex", gap: 20 }}>
              <div ref={filterRef} style={{ position: "relative" }}>
                {/* Red dot indicator when filter is applied */}
                {isFilterApplied && (
                  <span
                    style={{
                      position: "absolute",
                      top: 8,
                      left: 8,
                      width: 10,
                      height: 10,
                      background: "#F44336",
                      borderRadius: "50%",
                      zIndex: 2,
                      border: "2px solid #fff",
                    }}
                  />
                )}
                <Button
                  style={{
                    border: "1px solid #EAF1FA",
                    borderRadius: "8px",
                    height: "40px",
                    padding: 15,
                    color: "#6C6F71",
                    fontSize: "12px",
                    fontWeight: 600,
                    gap: 10,
                  }}
                  onClick={() => {
                    setTempFilterValues(appliedFilterValues);
                    setOpenFilter(!openFilter);
                  }}
                >
                  <FIlterIcon />
                  Filter
                </Button>

                {openFilter && (
                  <div
                    style={{
                      position: "absolute",
                      marginTop: 10,
                      backgroundColor: "white",
                      borderRadius: "8px",
                      width: isMobile ? "240px" : "400px",
                      right: isMobile ? "" : "0px",
                      zIndex: 1000,
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                      marginBottom: 20,
                    }}
                  >
                    <div>
                      <p
                        style={{
                          padding: 10,
                          paddingTop: 16,
                          paddingLeft: 16,
                          borderBottom: "1px solid #EDF2F6",
                          color: "#01060B",
                          fontSize: "16px",
                          fontWeight: 500,
                        }}
                      >
                        Filter
                      </p>
                      <Formik
                        initialValues={{
                          startDate: "",
                          endDate: "",
                          status: "",
                        }}
                        onSubmit={() => {}}
                        validateOnChange={true}
                      >
                        {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          isSubmitting,
                          handleSubmit,
                          setFieldValue,
                        }) => (
                          <div style={{ padding: "10px 20px" }}>
                            {/**Dates */}
                            <LocalizationProvider
                              dateAdapter={AdapterDayjs}
                              adapterLocale="en-gb"
                            >
                              <Box
                                sx={{
                                  display: isMobile ? "grid" : "flex",
                                  justifyContent: "space-between",
                                  gap: 2,
                                }}
                              >
                                {/* Start Date */}
                                <div>
                                  <label
                                    style={{
                                      fontWeight: 500,
                                      color: "#2C3034",
                                      fontSize: "16px",
                                      marginBottom: 5,
                                      display: "block",
                                    }}
                                  >
                                    Start date
                                  </label>
                                  <DatePicker
                                    format="DD/MM/YYYY"
                                    value={startDate}
                                    maxDate={endDate || dayjs()} // ⬅ Disable future dates
                                    //minDate={dayjs().startOf("day")}

                                    onChange={(val) => {
                                      setFieldValue("startDate", val);
                                      setStartDate(val);
                                      if (
                                        endDate &&
                                        val &&
                                        val.isAfter(endDate)
                                      ) {
                                        setEndDate(val);
                                        setFieldValue("endDate", val);
                                      }
                                    }}
                                    open={startDateOpen}
                                    onOpen={() => setStartDateOpen(true)}
                                    onClose={() => setStartDateOpen(false)}
                                    slotProps={{
                                      textField: {
                                        fullWidth: true,
                                        size: "medium",
                                        sx: {
                                          flex: 1,
                                          width: "172px",
                                          boxShadow:
                                            "0px 2px 4px 0px #D1DEEB33",
                                          "& .MuiOutlinedInput-root": {
                                            "& fieldset": {
                                              border: "0.5px solid #EAF1FA",
                                              borderRadius: "8px",
                                            },
                                            "&:hover fieldset": {
                                              border: "0.5px solid #EAF1FA",
                                              borderRadius: "8px",
                                            },
                                            "&.Mui-focused fieldset": {
                                              border: "0.5px solid #2977CC",
                                            },
                                          },
                                        },
                                        onClick: () => setStartDateOpen(true),
                                      },
                                    }}
                                  />
                                  {/* {touched.invoiceDate && errors.invoiceDate && (
                              <div
                                style={{
                                  color: "red",
                                  fontSize: "16px",
                                  marginTop: "4px",
                                  marginLeft: "4px",
                                }}
                              >
                                {errors.invoiceDate}
                              </div>
                            )} */}
                                </div>

                                {/* End Date */}
                                <div>
                                  <label
                                    style={{
                                      fontWeight: 500,
                                      color: "#2C3034",
                                      fontSize: "16px",
                                      marginBottom: 5,
                                      display: "block",
                                    }}
                                  >
                                    End date
                                  </label>
                                  <DatePicker
                                    format="DD/MM/YYYY"
                                    value={endDate}
                                    // minDate={
                                    //   values.invoiceDate
                                    //     ? values.invoiceDate
                                    //     : dayjs().startOf("day")
                                    // }
                                    minDate={startDate ?? undefined} // ⬅ cannot be less than startDate
                                    maxDate={dayjs()}
                                    // maxDate={dayjs().startOf("day")} // ⬅ Disable future dates
                                    onChange={(val) => {
                                      setFieldValue("endDate", val);
                                      setEndDate(val);
                                    }}
                                    open={endDateOpen}
                                    onOpen={() => setEndDateOpen(true)}
                                    onClose={() => setEndDateOpen(false)}
                                    slotProps={{
                                      textField: {
                                        fullWidth: true,
                                        size: "medium",
                                        sx: {
                                          flex: 1,
                                          width: "172px",
                                          boxShadow:
                                            "0px 2px 4px 0px #D1DEEB33",
                                          "& .MuiOutlinedInput-root": {
                                            "& fieldset": {
                                              border: "0.5px solid #EAF1FA",
                                              borderRadius: "8px",
                                            },
                                            "&:hover fieldset": {
                                              border: "0.5px solid #EAF1FA",
                                              borderRadius: "8px",
                                            },
                                            "&.Mui-focused fieldset": {
                                              border: "0.5px solid #2977CC",
                                            },
                                          },
                                        },
                                        inputProps: { readOnly: true },
                                        onClick: () => setEndDateOpen(true),
                                      },
                                    }}
                                  />
                                  {/* {touched.endDate && errors.endDate && (
                                    <div
                                      style={{
                                        color: "red",
                                        fontSize: "16px",
                                        marginTop: "4px",
                                        marginLeft: "4px",
                                      }}
                                    >
                                      {errors.endDate}
                                    </div>
                                  )} */}
                                </div>
                              </Box>
                            </LocalizationProvider>

                            {/**Status filter */}
                            <div
                              ref={statusRef}
                              style={{ position: "relative" }}
                            >
                              <div
                                style={{
                                  fontWeight: 500,
                                  color: "#2C3034",
                                  fontSize: "16px",
                                  marginBottom: 5,
                                  display: "block",
                                  marginTop: 14,
                                }}
                              >
                                Status
                              </div>
                              {/* Red dot indicator when filter is applied */}
                              <Button
                                style={{
                                  border: "0.5px solid #EAF1FA",
                                  borderRadius: "8px",
                                  height: "40px",
                                  padding: 15,
                                  color: "#97999B",
                                  fontSize: "16px",
                                  fontWeight: 500,
                                  width: "100%",
                                }}
                                onClick={() => {
                                  setOpenFilterStatus(!openFilterStatus);
                                }}
                              >
                                {filterStatusValue?.length ? (
                                  <p
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      width: "100%",
                                      color: "black",
                                      fontWeight: 400,
                                    }}
                                  >
                                    {filterStatusValue?.length > 30
                                      ? `${filterStatusValue?.slice(0, 30)}...`
                                      : filterStatusValue}
                                    <DownArrowIcon />
                                  </p>
                                ) : (
                                  <p
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      width: "100%",
                                    }}
                                  >
                                    {" "}
                                    Select Status
                                    <DownArrowIcon />
                                  </p>
                                )}
                              </Button>
                              {openFilterStatus && (
                                <div
                                  style={{
                                    position: "absolute",
                                    marginTop: 10,
                                    backgroundColor: "white",
                                    borderRadius: "8px",
                                    width: "480px",
                                    right: isMobile ? "" : "0px",
                                    zIndex: 1000,
                                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                                    marginBottom: 20,
                                  }}
                                >
                                  {openFilterStatus && (
                                    <Menu
                                      open={openFilterStatus}
                                      anchorEl={statusRef.current}
                                      onClose={() => setOpenFilterStatus(false)}
                                      anchorOrigin={{
                                        vertical: "bottom",
                                        horizontal: "right",
                                      }}
                                      transformOrigin={{
                                        vertical: "top",
                                        horizontal: "right",
                                      }}
                                      PaperProps={{
                                        style: {
                                          height:
                                            STATUS?.length > 1 ? "160px" : "",
                                          borderRadius: "8px",
                                          marginTop: 10,
                                          width: "360px",
                                          boxShadow:
                                            "0px 2px 4px rgba(0, 0, 0, 0.2)",
                                        },
                                      }}
                                    >
                                      {STATUS?.map((item: any, idx: number) => (
                                        <MenuItem
                                          key={item?.id}
                                          onClick={() => {
                                            console.log(
                                              "Filter by year:",
                                              item,
                                            );
                                            setOpenFilterStatus(false);
                                            setFilterStatusValue(item?.label);
                                            setSelectedStatusId(item?.id);
                                          }}
                                          sx={{
                                            borderRadius: "6px",
                                            "&:hover": {
                                              backgroundColor: "#A7C7EA66", // light blue hover
                                              color: "#1D538F",
                                              borderRadius: 0,
                                            },
                                            borderBottom:
                                              idx <= STATUS?.length - 2
                                                ? "1px solid #EDF2F6"
                                                : "",
                                            color: "#6C6F71",
                                            fontWeight: 500,
                                            fontSize: "16px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              width: "100%",
                                              paddingTop: 2,
                                              paddingBottom: 2,
                                            }}
                                          >
                                            {item?.label}
                                          </div>
                                        </MenuItem>
                                      ))}
                                    </Menu>
                                  )}
                                </div>
                              )}
                            </div>
                            <div
                              style={{
                                marginTop: 20,
                                display: isMobile ? "grid" : "flex",
                                alignItems: "center",
                                justifyContent: isMobile ? "center" : "",
                                gap: 20,
                              }}
                            >
                              <Button
                                disabled={
                                  !(
                                    (dayjs(startDate).isValid() &&
                                      dayjs(endDate).isValid()) ||
                                    filterStatusValue?.length
                                  )
                                }
                                type="submit"
                                sx={{
                                  width: "130px",
                                  fontSize: "14px",
                                  fontWeight: 600,
                                  color: "#fff",
                                  height: "36px",
                                  background: !(
                                    (dayjs(startDate).isValid() &&
                                      dayjs(endDate).isValid()) ||
                                    filterStatusValue?.length
                                  )
                                    ? "#BDBDBD"
                                    : "linear-gradient(to right, #2977CC, #1D538F)",
                                  cursor: !(
                                    (dayjs(startDate).isValid() &&
                                      dayjs(endDate).isValid()) ||
                                    filterStatusValue?.length
                                  )
                                    ? "not-allowed"
                                    : "pointer",
                                  opacity: !(
                                    (dayjs(startDate).isValid() &&
                                      dayjs(endDate).isValid()) ||
                                    filterStatusValue?.length
                                  )
                                    ? 0.7
                                    : 1,
                                }}
                                onClick={() => fetchData()}
                                //  setFilterLoading(true);
                                // setAppliedFilterValues(tempFilterValues);
                                // console.log(appliedFilterValues, "applied")
                                // setOpenFilter(false);
                                // await dispatch<any>(
                                //   getTransactionsTableData({
                                //     page: pageNo,
                                //     limit: 10,
                                //     transaction_type: value === 0 ? 2 : 1,
                                //     search: searchValue,
                                //     filter_by_category: categoryID,
                                //     start_date: startDate?.toString() || "",
                                //     end_date: endDate?.toString() || "",
                                //   })
                                // )
                                //   .then((res: any) => {
                                //     setData(res?.payload?.data?.summary);
                                //     setIsFilterApplied(true);
                                //     console.log("Filtered data:", res);
                                //   })
                                //   .finally(() => setFilterLoading(false));
                              >
                                Apply
                              </Button>
                              <button
                                disabled={
                                  !(
                                    (dayjs(startDate).isValid() &&
                                      dayjs(endDate).isValid()) ||
                                    filterStatusValue?.length
                                  )
                                }
                                style={{
                                  textAlign: "center",
                                  border: "none",
                                  fontSize: "14px",
                                  fontWeight: 600,
                                  background:
                                    "linear-gradient(to right, #2977CC, #1D538F)",
                                  WebkitBackgroundClip: "text",
                                  WebkitTextFillColor: "transparent",
                                  cursor: !(
                                    (dayjs(startDate).isValid() &&
                                      dayjs(endDate).isValid()) ||
                                    filterStatusValue?.length
                                  )
                                    ? "not-allowed"
                                    : "pointer",
                                  opacity: !(
                                    (dayjs(startDate).isValid() &&
                                      dayjs(endDate).isValid()) ||
                                    filterStatusValue?.length
                                  )
                                    ? 0.5
                                    : 1,
                                }}
                                onClick={() => {
                                  // setFilterLoading(true);

                                  resetFilters();
                                  // dispatch<any>(
                                  //   getTransactionsTableData({
                                  //     page: pageNo,
                                  //     limit: 10,
                                  //     transaction_type: value === 0 ? 2 : 1,
                                  //     filter_by_category: 0,
                                  //     search: "",
                                  //     start_date: "",
                                  //     end_date: "",
                                  //   })
                                  // )
                                  //   .then((res: any) => {
                                  //     setData(res?.payload?.data?.summary);
                                  //     setIsFilterApplied(false);
                                  //   })
                                  //   .finally(() => setFilterLoading(false));
                                  setOpenFilter(false);
                                }}
                              >
                                Reset filter
                              </button>
                            </div>
                          </div>
                        )}
                      </Formik>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                "@media (min-width: 600px)": {
                  flexDirection: "row",
                  alignItems: "center",
                },
              }}
            >
              <SearchWrapper>
                <SearchIcon />
                <StyledInputBase
                  placeholder="Search here..."
                  inputProps={{ "aria-label": "search" }}
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
                {searchQuery && (
                  <CloseButtonWrapper>
                    <CloseButton
                      onClick={() => {
                        setSearchQuery("");
                      }}
                      sx={{
                        cursor: "pointer",
                        display: "inline-flex",
                        color: "red",
                        position: "absolute",
                        right: "1px",
                        top: "6.5px",
                      }}
                    >
                      <CrossIcon />
                    </CloseButton>
                  </CloseButtonWrapper>
                )}
              </SearchWrapper>
            </Box>
          </div>
        </Box>

        <CustomTable
          headings={[
            "Sr. No",
            "Client Name",
            "Service Name",
            "Order Source",
            "Created date",
            "Status",
            "Action",
          ]}
        >
          <>
            {loading && (
              <TableRow>
                <TableCell colSpan={7}>
                  <ListLoadingNew />
                </TableCell>
              </TableRow>
            )}

            {!loading && orderList?.length === 0 && (
              <TableRow>
                <TableCell colSpan={7}>
                  <NoOrdersFound
                    title="No Order Found"
                    breakWords={["submitted"]}
                    subTitle="It looks like no order have been submitted yet."
                  />
                </TableCell>
              </TableRow>
            )}
            {!loading &&
              orderList?.length > 0 &&
              orderList?.map((item: any, index: number) => (
                <TableRow key={item?.id || index}>
                  <TableCell
                    sx={{
                      padding: "16px 24px",
                    }}
                  >
                    <Typography>{(page - 1) * limit + index + 1}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      sx={{
                        whiteSpace: "nowrap",
                      }}
                    >
                      {item?.client_name || "-"}
                    </Typography>
                  </TableCell>
                  <TableCell
                    sx={{
                      whiteSpace: "nowrap",
                    }}
                  >
                    <Typography>{item?.product_name || "-"}</Typography>
                  </TableCell>
                  <TableCell
                    sx={{
                      whiteSpace: "nowrap",
                    }}
                  >
                    <Typography>{item?.order_source || "-"}</Typography>
                  </TableCell>
                  <TableCell
                    sx={{
                      whiteSpace: "nowrap",
                    }}
                  >
                    <Typography>
                      {item?.created_at
                        ? formatToTimeZone(item.created_at)
                        : "-"}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    {item?.product_id === 1 && (
                      <Box
                        sx={{
                          minWidth: "113px",
                          width: "auto",
                          textAlign: "center",
                          display: "inline-block",
                          padding: "9px",
                          borderRadius: "6px",
                          fontSize: "12px",
                          fontWeight: "600",
                          backgroundColor:
                            itinStatus[item?.status]?.bgColor || "#ccc",
                          color: itinStatus[item?.status]?.textColor || "#000",
                          whiteSpace: "nowrap",
                          cursor: "pointer",
                        }}
                      >
                        {itinStatus[item?.status]?.label || "-"}
                      </Box>
                    )}
                    {item?.product_id === 2 && (
                      <Box
                        sx={{
                          minWidth: "113px",
                          width: "auto",
                          textAlign: "center",
                          display: "inline-block",
                          padding: "9px",
                          borderRadius: "6px",
                          fontSize: "12px",
                          fontWeight: "600",
                          backgroundColor:
                            LlcStatus[item?.status]?.bgColor || "#ccc",
                          color: LlcStatus[item?.status]?.textColor || "#000",
                          whiteSpace: "nowrap",
                          cursor: "pointer",
                        }}
                      >
                        {LlcStatus[item?.status]?.label || "-"}
                      </Box>
                    )}
                    {item?.product_id === 3 && (
                      <Box
                        sx={{
                          minWidth: "113px",
                          width: "auto",
                          textAlign: "center",
                          display: "inline-block",
                          padding: "9px",
                          borderRadius: "6px",
                          fontSize: "12px",
                          fontWeight: "600",
                          backgroundColor:
                            LlcStatus[item?.status]?.bgColor || "#ccc",
                          color: LlcStatus[item?.status]?.textColor || "#000",
                          whiteSpace: "nowrap",
                          cursor: "pointer",
                        }}
                      >
                        {LlcStatus[item?.status]?.label || "-"}
                      </Box>
                    )}
                    {item?.product_id === 5 && (
                      <Box
                        sx={{
                          minWidth: "113px",
                          width: "auto",
                          textAlign: "center",
                          display: "inline-block",
                          padding: "9px",
                          borderRadius: "6px",
                          fontSize: "12px",
                          fontWeight: "600",
                          backgroundColor:
                            operatingAgreementStatus[item?.status]?.bgColor ||
                            "#ccc",
                          color:
                            operatingAgreementStatus[item?.status]?.textColor ||
                            "#000",
                          whiteSpace: "nowrap",
                          cursor: "pointer",
                        }}
                      >
                        {operatingAgreementStatus[item?.status]?.label || "-"}
                      </Box>
                    )}
                    {(item?.product_id === 6 || item?.product_id === 4) && (
                      <Box
                        sx={{
                          minWidth: "113px",
                          width: "auto",
                          textAlign: "center",
                          display: "inline-block",
                          padding: "9px",
                          borderRadius: "6px",
                          fontSize: "12px",
                          fontWeight: "600",
                          backgroundColor:
                            operatingAgreementStatus[item?.status]?.bgColor ||
                            "#ccc",
                          color:
                            operatingAgreementStatus[item?.status]?.textColor ||
                            "#000",
                          whiteSpace: "nowrap",
                          cursor: "pointer",
                        }}
                      >
                        {operatingAgreementStatus[item?.status]?.label || "-"}
                      </Box>
                    )}
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "16px 24px",
                    }}
                  >
                    {item?.product_id !== 6 && item?.product_id !== 4 && (
                      <Box
                        onClick={
                          () =>
                            handleSelect(
                              item?.id,
                              item?.product_id,
                              item?.user_id,
                            )
                          // navigate(`/admin-orders/${item?.id}`)
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <ArrowRightCircleIcon />
                      </Box>
                    )}
                  </TableCell>
                </TableRow>
              ))}
          </>
        </CustomTable>

        {/* Pagination */}
        {Math.ceil(total_records / limit) > 1 && (
          <Box sx={{ display: "flex", justifyContent: "end", mt: 3 }}>
            <CommonPagination
              currentPage={page}
              totalPages={Math.ceil(total_records / limit)}
              onPageChange={handlePageChange}
            />
          </Box>
        )}
      </StyledBox>
    </>
  );
};

export default Orders;

const StyledBox = styled(Box)({
  background: "#ffffff",
  boxShadow: "0px 2px 40px 0px #DDE3EA33",
  borderRadius: "10px",
});

const Container = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "20px",
});

const Title = styled(Typography)({
  color: "#01060B !important",
  fontSize: "20px !important",
  fontWeight: "600 !important",
});

const SearchContainer = styled(Box)({
  display: "flex",
  gap: "10px",
  alignItems: "center",
});

const SearchWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  background: "#F6F9FD",
  color: "#6B6B6B",
  borderRadius: "8px",
  position: "relative",
  padding: "5px 10px",
  "&:hover": {
    background: "#F6F9FD",
  },
});

const StyledButton = styled(Button)({
  width: "120px !important",
  whiteSpace: "nowrap",
  borderRadius: "6px !important",
  height: "40px !important",
});

const StyledInputBase = styled(InputBase)({
  minWidth: "300px",
  padding: "3px",
});
